<template>
  <div>
    <Terms
      :showAgreement="showAgreement"
      @agreed="
        showAgreement = !showAgreement;
        checkbox = true;
      "
      v-if="showAgreement"
    />

    <div class="container-scroller" style="background: #f9fafb">
      <loading
        :active.sync="isLoading"
        :is-full-page="fullPage"
        background-color="#f3f3f3"
        :opacity="0.8"
        loader="spinner"
      ></loading>
      <!-- <div class="row">
        <div class="col-sm-5 col-12 left-column">
          <img
            src="../../assets/images/Login Imgs/Group 82.png"
            alt=""
            class="img-green"
          />

          <div
            style="position:relative"
            class=" mobile-lang d-sm-none"
            v-click-outside="hideDropMobile"
          >
            <div
              class="d-flex align-items-center cursor-pointer"
              style="column-gap:1rem; float:right"
              @click="show_drop_mobile = !show_drop_mobile"
            >
              <p class="mb-0" style="color: #5E6A79;">
                {{ $t("change-lang") }}
              </p>
              <div class="d-flex align-items-center">
                <span class="mr-2" style="color: #5E6A79;">{{ language }}</span>
                <IconDownArrow />
              </div>
            </div>
            <div
              class="dropdown-lang position-absolute p-10"
              v-if="show_drop_mobile"
            >
              <span
                class="d-flex justify-content-start align-items-center cursor-pointer hover-item"
                style="column-gap:0.7rem;"
                @click="switchLang('en', 'EN')"
              >
                <input
                  type="radio"
                  class="radio-btn"
                  :checked="language === 'EN'"
                />
                <span style="color: #5E6A79;">English - EN</span>
              </span>
              <span
                class="d-flex justify-content-start align-items-center cursor-pointer hover-item"
                style="column-gap:0.7rem"
                @click="switchLang('fr', 'FR')"
              >
                <input type="radio" :checked="language === 'FR'" />
                <span style="color: #5E6A79;">French - FR</span>
              </span>
              <span
                class="d-flex justify-content-start align-items-center cursor-pointer hover-item"
                style="column-gap:0.7rem"
                @click="switchLang('sw', 'SW')"
              >
                <input type="radio" :checked="language === 'SW'" />
                <span style="color: #5E6A79;">Swahili - SW</span>
              </span>
            </div>
          </div>

          <div class="position-relative">
            <img
              src="../../assets/images/Login Imgs/logo 3.png"
              alt=""
              class="gricd-logo"
            />
          </div>
          <div class="d-block lrg-txt">
            <h1>
              {{ $t("scale") }} <br />
              {{ $t("scale-2") }}
            </h1>
            <p>{{ $t("zero-stress") }}</p>
          </div>

          <p>{{ $t("real-time") }}</p>
        </div>
        <div class="col">
          <div class="container-fluid page-body-wrapper full-page-wrapper">
            <div
              class="vh-100 content-wrapper auth-wrapper no-block justify-content-between align-items-center auth auth-img-bg position-relative"
              style="display: flex;flex-flow: column;justify-content: space-between;padding:0"
            >
              <div
                class="d-flex justify-content-end align-items-center flex-grow w-100 hide-lang"
              >
                <div style="position:relative" v-click-outside="hideDrop">
                  <div
                    class="d-flex align-items-center cursor-pointer"
                    style="column-gap:1rem; float:right"
                    @click="show_drop = !show_drop"
                  >
                    <p class="mb-0" style="color: #5E6A79;">
                      {{ $t("change-lang") }}
                    </p>
                    <div class="d-flex align-items-center">
                      <span class="mr-2" style="color: #5E6A79;">{{
                        language
                      }}</span>
                      <IconDownArrow />
                    </div>
                  </div>
                  <div
                    class="dropdown-lang position-absolute p-10"
                    v-if="show_drop"
                  >
                    <span
                      class="d-flex justify-content-start align-items-center cursor-pointer hover-item"
                      style="column-gap:0.7rem;"
                      @click="switchLang('en-GB', 'EN')"
                    >
                      <input
                        type="radio"
                        class="radio-btn"
                        :checked="language === 'EN'"
                      />
                      <span style="color: #5E6A79;">English - EN</span>
                    </span>
                    <span
                      class="d-flex justify-content-start align-items-center cursor-pointer hover-item"
                      style="column-gap:0.7rem"
                      @click="switchLang('fr-FR', 'FR')"
                    >
                      <input type="radio" :checked="language === 'FR'" />
                      <span style="color: #5E6A79;">French - FR</span>
                    </span>
                    <span
                      class="d-flex justify-content-start align-items-center cursor-pointer hover-item"
                      style="column-gap:0.7rem"
                      @click="switchLang('sw', 'SW')"
                    >
                      <input type="radio" :checked="language === 'SW'" />
                      <span style="color: #5E6A79;">Swahili - SW</span>
                    </span>
                  </div>
                </div>
              </div>
              <div style="bottom:0;width: 100%;" class="right-form">
                <div class="col-12">
                  <div class="auth-form-transparent">
                    <div class="brand-logo " align="center">
                      <img
                        src="../../assets/images/logo.png"
                        alt="logo"
                        height="45"
                      />
                    </div>
                    <div align="center">
                      <h5 class="pt-3">
                        {{ $t("welcome") }}
                      </h5>
                    </div>
                    <div
                      v-if="msg"
                      align="center"
                      class="alert alert-danger alert-dismissible fade show text-center margin-bottom-1x"
                    >
                      <p class="alert-close mb-0">
                        {{ mssg }}
                      </p>
                    </div>
                    <form
                      autocomplete="off"
                      @submit.prevent="onSubmit"
                      class=""
                    >
                      <div class="form-group">
                        <label for="InputFullname">{{ $t("fullname") }}</label>
                        <div class="form-group">
                          <input
                            type="text"
                            class="form-control "
                            id="Inputname"
                            required
                            autocomplete="off"
                            v-model="fullname"
                            name="fullname"
                            v-on:keydown="isLetter($event)"
                          />
                          <div
                            v-show="selectNotification !== ''"
                            class="alert-danger alert-dismissible fade show"
                          >
                            <p>{{ selectNotification }}</p>
                          </div>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="InputNumber">{{ $t("country") }}</label>
                        <div class="form-group">
                          <select
                            @change="changeNumber"
                            style="outline: none;"
                            class="form-control"
                            v-model="country"
                            id="country"
                          >
                            <option
                              :key="index"
                              v-for="(country, index) in iti.countries"
                              :value="country.iso2"
                              >{{ country.name }}</option
                            >
                          </select>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="InputCompany">{{ $t("company") }}</label>
                        <div class="form-group">
                          <input
                            type="text"
                            class="form-control "
                            id="InputCompany"
                            required
                            autocomplete="off"
                            v-model="company"
                            name="company"
                          />
                        </div>
                      </div>
                      <div class="position-relative form-group">
                        <label for="InputEmail">{{ $t("email") }}</label>
                        <div class="form-group mb-2">
                          <input
                            type="text"
                            class="form-control "
                            id="InputEmail"
                            autocomplete="off"
                            required
                            v-model="email"
                            name="email"
                          />
                        </div>
                        <div
                          v-if="this.validatedMail"
                          class="position-absolute"
                          style="top: 2.3rem; right: 0.5rem; color: #213e7a"
                        >
                          <i class="far fa-check-circle"></i>
                        </div>
                        <p v-if="isErrorMail" class="my-0 small text-error p-1">
                          {{ messageMail }}
                        </p>
                      </div>

                      <div class="form-group">
                        <label for="InputNumber">{{ $t("phone_num") }}</label>
                        <div class="form-group">
                          <input
                            class="form-control"
                            autocomplete="off"
                            v-model="phone_number"
                            type="tel"
                            id="phone_number"
                          />
                        </div>
                        <p
                          v-if="isErrorPhone"
                          class="my-0 small text-error p-1"
                        >
                          {{ messagePhone }}
                        </p>
                      </div>

                      <div class="position-relative form-group">
                        <label for="InputPassword">{{ $t("password") }}</label>
                        <div class="form-group mb-2">
                          <input
                            :type="show === true ? 'text' : 'password'"
                            class="form-control"
                            id="InputPassword"
                            required
                            autocomplete="off"
                            v-model="password"
                            name="password"
                          />
                          <p class="small gray4">
                            {{ $t("signup-text") }}
                          </p>
                        </div>
                        <div
                          class="position-absolute mb-4 mr-2"
                          style="cursor: pointer; top: 2.3rem; right: 0.5rem;"
                        >
                          <div :key="'show'" @click="show = !show" v-if="!show">
                            <i class="fas fa-eye"></i>
                          </div>
                          <div :key="'!show'" @click="show = !show" v-else>
                            <i class="far fa-eye-slash"></i>
                          </div>
                        </div>
                        <p v-if="isErrorPassword" class="small text-error p-1">
                          {{ messagePassword }}
                        </p>
                        <div
                          style="height: 0.25rem; border-radius: 5px"
                          :class="getClass()"
                        ></div>
                      </div>

                      <div
                        class="form-check d-flex justify-content-center align-items-center col-gap-1"
                      >
                        <input
                          class="form-check-input cursor-pointer"
                          type="checkbox"
                          id="Checkbox1"
                          required
                          v-model="checkbox"
                          name="checkbox"
                        />
                        <label
                          class="form-check-label mb-0 cursor-pointer"
                          for="Checkbox1"
                        >
                          {{ $t("agree") }}
                          <a
                            href="javascript:void(0)"
                            v-click-outside="closeModal"
                            @click="showAgreement = !showAgreement"
                            >{{ $t("terms") }}</a
                          >
                        </label>
                      </div>

                      <div class="my-3" align="center">
                        <div
                          v-if="Errormssg"
                          align="center"
                          class="alert alert-danger alert-dismissible fade show text-center margin-bottom-1x mb-3"
                        >
                          <p class="alert-close mb-0">
                            {{ Errormssg }}
                          </p>
                        </div>
                        <button
                          type="submit"
                          style="width: 50%"
                          class="btn btn-primary"
                          :disabled="selectNotification !== '' || !checkbox"
                        >
                          {{ $t("create_acc") }}
                        </button>
                      </div>

                      <div align="center">
                        <p class="mt-0 p-1">
                          {{ $t("have_acc") }}
                          <router-link class="text-primary" to="/login">{{
                            $t("login")
                          }}</router-link>
                        </p>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> -->

      <AuthWrapper @new_language="updateLang">
        <template slot="content">
          <div class="auth-form-transparent">
            <h2 class="text-center create-acc mb-3">{{ $t("create-acc") }}</h2>
            <div>
              <h5 class="font-14 gray4 text-center">
                {{ $t("welcome") }}
              </h5>
            </div>
            <div
              v-if="msg"
              class="alert alert-danger alert-dismissible fade show text-center margin-bottom-1x"
            >
              <p class="alert-close mb-0">
                {{ msg }}
              </p>
            </div>
            <form autocomplete="off" @submit.prevent="onSubmit" class="">
              <div class="form-group">
                <label for="InputFullname">{{ $t("fullname") }}</label>
                <div class="form-group">
                  <input
                    type="text"
                    class="form-control "
                    id="Inputname"
                    required
                    autocomplete="off"
                    v-model="fullname"
                    name="fullname"
                    v-on:keydown="isLetter($event)"
                  />
                  <div
                    v-show="selectNotification !== ''"
                    class="alert-danger alert-dismissible fade show"
                  >
                    <p>{{ selectNotification }}</p>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label for="InputNumber">{{ $t("country") }}</label>
                <div class="form-group">
                  <select
                    @change="changeNumber"
                    style="outline: none;"
                    class="form-control"
                    v-model="country"
                    id="country"
                  >
                    <option
                      :key="index"
                      v-for="(country, index) in iti.countries"
                      :value="country.iso2"
                      >{{ country.name }}</option
                    >
                  </select>
                </div>
              </div>

              <div class="form-group">
                <label for="InputCompany">{{ $t("company") }}</label>
                <div class="form-group">
                  <input
                    type="text"
                    class="form-control "
                    id="InputCompany"
                    required
                    autocomplete="off"
                    v-model="company"
                    name="company"
                  />
                </div>
              </div>
              <div class="position-relative form-group">
                <label for="InputEmail">{{ $t("email") }}</label>
                <div class="form-group mb-2">
                  <input
                    type="text"
                    class="form-control "
                    id="InputEmail"
                    autocomplete="off"
                    required
                    v-model="email"
                    name="email"
                  />
                </div>
                <div
                  v-if="this.validatedMail"
                  class="position-absolute"
                  style="top: 2.3rem; right: 0.5rem; color: #213e7a"
                >
                  <i class="far fa-check-circle"></i>
                </div>
                <p v-if="isErrorMail" class="my-0 small text-error p-1">
                  {{ messageMail }}
                </p>
              </div>

              <div class="form-group">
                <label for="InputNumber">{{ $t("phone_num") }}</label>
                <div class="form-group">
                  <input
                    class="form-control"
                    autocomplete="off"
                    v-model="phone_number"
                    type="tel"
                    id="phone_number"
                  />
                </div>
                <p v-if="isErrorPhone" class="my-0 small text-error p-1">
                  {{ messagePhone }}
                </p>
              </div>

              <div class="position-relative form-group">
                <label for="InputPassword">{{ $t("password") }}</label>
                <div class="form-group mb-2">
                  <input
                    :type="show === true ? 'text' : 'password'"
                    class="form-control"
                    id="InputPassword"
                    required
                    autocomplete="off"
                    v-model="password"
                    name="password"
                  />
                  <p class="font-12 mt-3 gray4">
                    {{ $t("signup-text") }}
                  </p>
                </div>
                <div
                  class="position-absolute mb-4 mr-2"
                  style="cursor: pointer; top: 2.3rem; right: 0.5rem;"
                >
                  <div :key="'show'" @click="show = !show" v-if="!show">
                    <i class="fas fa-eye"></i>
                  </div>
                  <div :key="'!show'" @click="show = !show" v-else>
                    <i class="far fa-eye-slash"></i>
                  </div>
                </div>
                <p v-if="isErrorPassword" class="small text-error p-1">
                  {{ messagePassword }}
                </p>
                <div
                  style="height: 0.25rem; border-radius: 5px"
                  :class="getClass()"
                ></div>
              </div>

              <div class="form-check d-flex align-items-center col-gap-1">
                <input
                  class="form-check-input cursor-pointer"
                  type="checkbox"
                  id="Checkbox1"
                  required
                  v-model="checkbox"
                  name="checkbox"
                />
                <label
                  class="form-check-label mb-0 cursor-pointer"
                  for="Checkbox1"
                >
                  {{ $t("agree") }}
                  <a
                    href="javascript:void(0)"
                    v-click-outside="closeModal"
                    @click="showAgreement = !showAgreement"
                    >{{ $t("terms") }}</a
                  >
                </label>
              </div>

              <div class="my-3" align="center">
                <div
                  v-if="Errormssg"
                  class="alert alert-danger alert-dismissible fade show text-center margin-bottom-1x mb-3"
                >
                  <p class="alert-close mb-0">
                    {{ Errormssg }}
                  </p>
                </div>
                <button
                  type="submit"
                  style="width: 50%; border-radius: 5px"
                  class="btn btn-primary w-100"
                  :disabled="selectNotification !== '' || !checkbox"
                >
                  {{ $t("create_acc") }}
                </button>
              </div>

              <div>
                <p class="mt-3 font-14 text-center p-1">
                  {{ $t("have_acc") }}
                  <router-link class="text-primary" to="/login">{{
                    $t("login")
                  }}</router-link>
                </p>
              </div>
            </form>
          </div>
        </template>
      </AuthWrapper>
      <!-- page-body-wrapper ends -->
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import * as intlTelInput from "../../assets/js/intlTelInput";
import * as utils from "../../assets/js/utils";
import vClickOutside from "v-click-outside";
// import IconDownArrow from "../../components/Iconsvg/IconDownArrow2.vue";
import Terms from "../Modals/Terms.vue";
import AuthWrapper from "./AuthWrapper.vue";

export default {
  name: "SignupPage",
  data() {
    return {
      fullname: "",
      company: "",
      email: "",
      password: "",
      isErrorPhone: false,
      isErrorMail: false,
      isErrorPassword: false,
      messagePhone: "",
      messageMail: "",
      messagePassword: "",
      msg: "",
      Errormssg: "",
      isLoading: false,
      fullPage: true,
      show: false,
      phone_number: "",
      iti: "",
      country: "ng",
      langs: ["en", "fr-FR", "es-ES"],
      language: "EN",
      show_drop: false,
      show_drop_mobile: false,
      selectNotification: "",
      checkbox: false,
      showAgreement: false,
      langKeys: {
        en: "EN",
        fr: "FR",
        sw: "SW",
      },
    };
  },
  components: {
    Loading,
    Terms,
    AuthWrapper,
  },
  directives: {
    clickOutside: vClickOutside.directive,
  },
  mounted() {
    var input = document.querySelector("#phone_number");
    this.iti = intlTelInput(input, {
      separateDialCode: true,
      utilsScript: utils,
    });
    this.iti.setCountry(this.country);
    this.language = this.langKeys[this.$i18n.locale];
  },
  computed: {
    validatedMail() {
      var reg = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/;
      return reg.test(this.email) ? true : false;
    },
    scorePassword() {
      let score = 1;
      if (this.password === "") return score;
      if (this.password.length >= 8) {
        score++;
      }
      let variations = [
        /\d/.test(this.password),
        /[a-z]/.test(this.password),
        /[A-Z]/.test(this.password),
        /\W/.test(this.password),
      ];
      for (let i = 0; i < variations.length; i++) {
        if (variations[i] === true) {
          score++;
        }
      }
      return parseInt(score);
    },
  },
  methods: {
    ...mapActions(["register"]),
    changeNumber() {
      this.iti.setCountry(this.country);
      // console.log(this.country);
    },
    getClass() {
      if (this.scorePassword < 2) return "bg-gray2 w-100";
      if (this.scorePassword == 2) return "bg-danger w-25";
      else if (this.scorePassword == 3 || this.scorePassword == 4)
        return "bg-orange w-50";
      else if (this.scorePassword == 5) return "bg-warning w-75";
      else if (this.scorePassword == 6) return "bg-success w-100";
    },
    errorMssgPhone(mssg) {
      this.isErrorPhone = true;
      this.messagePhone = mssg;
    },
    errorMssgMail(mssg) {
      this.isErrorMail = true;
      this.messageMail = mssg;
    },
    errorMssgPassword(mssg) {
      this.isErrorPassword = true;
      this.messagePassword = mssg;
    },
    isLetter(e) {
      let char = String.fromCharCode(e.keyCode); // Get the character
      if (/^[a-zA-Z\s\b]*$/.test(char)) return true;
      // Match with regex
      else e.preventDefault(); // If not match, don't add to input text
    },
    onSubmit() {
      this.isErrorPhone = false;
      this.isErrorMail = false;
      this.isErrorPassword = false;
      this.Errormssg = "";
      let countrycode = document.getElementById("country");
      let countryselected = this.iti.countries.filter(
        (country) => country.iso2 == countrycode.value
      );
      let number = this.iti.getNumber().slice(1);

      if (!this.iti.isValidNumber()) {
        this.errorMssgPhone("This phone number is not valid");
      }
      if (this.validatedMail === false) {
        this.errorMssgMail("This email address is incorrect");
      }
      if (this.password.length < 8) {
        this.errorMssgPassword("Password has to be at least 8 characters");
      } else if (this.scorePassword < 5) {
        this.errorMssgPassword(
          "Password must contain at least one uppercase, one lowercase, and one special character"
        );
      }
      if (
        this.validatedMail &&
        this.iti.isValidNumber() &&
        this.password.length >= 8 &&
        this.scorePassword >= 5
      ) {
        this.isLoading = true;
        var newUser = {
          fullname: this.fullname,
          phoneNumber: `${parseInt(number)}`,
          country: countryselected[0].name,
          email: this.email.toLowerCase(),
          password: this.password,
          companyName: this.company,
          termsAndConditions: this.checkbox,
        };
        this.register(newUser)
          .then((res) => {
            this.isLoading = false;
            if (res.data.success) {
              this.msg = res.data.payload.message;
              setTimeout(() => {
                this.isLoading = true;
              }, 1000);
              setTimeout(() => {
                this.$router.push("/companyprofile");
              }, 4000);
            }
          })
          .catch((error) => {
            this.isLoading = false;
            // error.response can be null
            console.log(error);
            console.log(error.response, "err response");
            if (error.response) {
              this.Errormssg = error.response.data.message;
              console.error(error.response.data.message);
              this;
            }
          });
      }
    },
    switchLang: function(lang, val) {
      // this.$i18n.locale = lang;
      this.$emit("new_language", lang);
      this.language = val;
    },
    hideDrop() {
      this.show_drop = false;
    },

    hideDropMobile() {
      this.show_drop_mobile = false;
    },
    closeModal() {
      this.showAgreement = false;
    },
    updateLang(lang) {
      this.$emit("new_language", lang);
    },
  },
  watch: {
    fullname: {
      handler() {
        if (/^[a-zA-Z\s]*$/.test(this.fullname))
          return (this.selectNotification = "");
        else this.selectNotification = this.$t("must_contain");
      },
    },
  },
};
</script>

<style scoped>
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.visible-append {
  cursor: pointer;
}
.left-column {
  /* padding: 0 3rem 1rem; */
  padding: 0 1rem 1rem 5rem;
  place-items: flex-start;
  display: flex;
  flex-flow: column;
  justify-content: space-between;
}
.left-column p {
  color: #5e6a79;
  font-family: Sarabun;
  font-style: normal;
  font-weight: 600;
  font-size: 1rem;
  line-height: 140.62%;
}

.left-column h1 {
  line-height: 1.2;
  font-weight: bolder;
  color: #212529;
  font-size: 2.75rem;
}
.left-column .d-block {
  z-index: 3;
}
.img-green {
  position: absolute;
  top: 0;
  left: 0;
  height: 90vh;
  z-index: 1;
}
.page-body-wrapper.full-page-wrapper {
  width: 100%;
  min-height: 100vh;
  padding-top: 0;
  max-width: 35rem;
}
.row-login {
  position: absolute;
  width: 100%;
  bottom: 0;
}
.lang {
  float: right;
  position: relative;
  top: 4rem;
}
/* .left-column .d-block {
  position: relative;
  top: 50%;
} */
.dropdown-lang {
  background: #ffffff;
  border: 0.3px solid rgba(99, 99, 99, 0.25);
  box-shadow: 0px 20px 50px rgba(29, 53, 71, 0.06);
  border-radius: 3px;
  z-index: 3 !important;
  top: 2rem;
  color: #5e6a79;
  /* width: calc(100% - 1.5rem); */
}
input[type="radio"] {
  border: 1px solid green !important;
}
input[type="radio"]:checked {
  background-color: red !important;
}
.radio-btn {
  border: 1px solid red !important;
}
.hover-item {
  padding: 8px;
}
.hover-item:hover {
  background-color: #f6f8f9;
}
.auth-form-transparent {
  height: 40rem;
  overflow-y: scroll;
  background: #ffffff;
  box-shadow: 0px 4px 10px rgba(138, 142, 148, 0.05);
  border-radius: 10px;
  padding: 1rem 1.5rem;
}
.gricd-logo {
  /* position: absolute;
  top: 3rem;
  height: 5rem;
  z-index: 3; */
  position: absolute;
  top: 5rem;
  height: 4rem;
  z-index: 3;
  left: 0rem;
  /* left: 3rem; */
}
@media (max-width: 576px) {
  .img-green {
    height: 50vh;
    width: calc(100% - 10rem);
  }
  .left-column h1 {
    margin-top: 5rem;
    font-size: 2rem;
  }
  .gricd-logo {
    /* position: absolute;
    top: 2rem;
    height: 2rem;
    z-index: 3;
    left: -1rem; */
    position: absolute;
    top: 1rem;
    height: 2rem;
    z-index: 3;
    left: 0rem;
  }
  .hide-lang {
    display: none !important;
  }
  .mobile-lang {
    top: 2.6rem;
    margin-left: auto;
    z-index: 10;
  }
  .left-column {
    /* padding: 0 3rem 1rem; */
    padding: 0 3rem 1rem 3rem;
    place-items: flex-start;
    display: flex;
    flex-flow: column;
    justify-content: space-between;
  }
  .vh-100 {
    height: auto !important;
  }
  .page-body-wrapper.full-page-wrapper {
    min-height: auto;
  }
  .btn {
    width: 55% !important;
  }
}
@media (max-width: 1250px) and (min-width: 900px) {
  .gricd-logo {
    position: absolute;
    top: 3rem;
    height: 3rem;
    z-index: 3;
    left: 2rem;
  }
  .auth-form-transparent {
    height: 26rem;
  }
}
@media (max-width: 2100px) and (min-width: 1680px) {
  .gricd-logo {
    position: absolute;
    /* top: 7rem; */
    height: 5rem;
    z-index: 3;
    left: 0rem;
    /* left: 4rem; */
  }
  .left-column {
    padding: 0 1rem 1rem 5rem;
  }
  .left-column h1 {
    line-height: 1.2;
    font-weight: bolder;
    color: #212529;
    /* font-size: 3.75rem; */
    font-size: 3.4rem;
  }
  .left-column p {
    color: #5e6a79;
    font-family: Sarabun;
    font-style: normal;
    font-weight: 600;
    font-size: 1.2rem;
    line-height: 140.62%;
  }
  .img-green {
    position: absolute;
    top: 0;
    left: 0;
    height: 88vh;
    /* height: 94vh; */
    z-index: 1;
  }
  .right-form {
    /* flex-grow: 1; */
    display: flex;
    align-items: end;
  }
  .right-form .col-12 {
    display: flex;
    flex-flow: column;
    /* width: 100%; */
    /* height: 100%; */
  }

  .right-form .col-12 .auth-form-transparent {
    width: 100% !important;
    /* height: 100%;
    display: flex;
    flex-flow: column;
    justify-content: space-evenly; */
    height: 38rem;
    overflow-y: scroll;
  }
  .page-body-wrapper.full-page-wrapper {
    width: 100%;
    min-height: 100vh;
    padding-top: 0;
    max-width: 39rem;
  }
  .brand-logo img {
    height: 4rem;
  }
  h5 {
    font-size: 1.2rem;
  }
  .auth form .form-group label {
    font-size: 1.05rem;
  }
  .auth .brand-logo {
    margin-bottom: 1rem;
  }
  p {
    font-size: 1.05rem;
  }
  .btn {
    font-size: 1.2rem;
  }
  .small {
    font-size: 0.875rem;
  }
}
input[type="checkbox"]:checked {
  accent-color: #213e7a;
  outline: 1px solid #213e7a;
}
a {
  color: #213e7a;
  text-decoration: underline;
}
.create-acc {
  font-weight: 700;
  font-size: 24px;
  color: #282828;
}
</style>

<i18n>
{
	"en": {
		"acc": "Don't have an account?",
		"agree": "I agree to the",
		"change-lang": "Change Language",
		"company": "Company",
		"country": "Country",
		"create_acc": "Create Account",
		"email": "Email",
		"fgt-pwd": "Forgot Password?",
		"fullname": "Full Name",
		"have_acc": "Already have an account?",
		"login": "Log in",
		"must_contain": "Must conain only Letters",
		"password": "Password",
		"phone_num": "Phone Number",
		"real-time": "With real-time data-backed decisions.",
		"scale": "Scale your Operation and",
		"scale-2": "increase profitability",
		"signup": "Sign Up",
		"signup-text": "Strong passwords should be 8 characters long with a mix of upper case, lower case, and special characters",
		"terms": "Terms & Conditions",
		"welcome": "Sign up and start monitoring your devices",
		"zero-stress": "No stress, zero hassle.",
    "create-acc":"Create an Account"
	},
	"es": {
		"acc": "¿No tienes una cuenta?",
		"agree": "Estoy de acuerdo con la",
		"change-lang": "Cambiar idioma",
		"company": "Empresa",
		"country": "País",
		"create_acc": "Crear una cuenta",
		"email": "Correo electrónico",
		"fgt-pwd": "¿Se te olvidó tu contraseña?",
		"fullname": "Nombre completo",
		"have_acc": "¿Ya tienes una cuenta?",
		"login": "Iniciar sesión",
		"must_contain": "Debe contener solo letras",
		"password": "Contraseña",
		"phone_num": "Número de teléfono",
		"real-time": "Con decisiones respaldadas por datos en tiempo real.",
		"scale": "Escale su operación y",
		"scale-2": "aumentar la rentabilidad",
		"signup": "Regístrate",
		"signup-text": "Las contraseñas seguras deben tener 8 caracteres con una combinación de mayúsculas, minúsculas y caracteres especiales.",
		"terms": "Términos y condiciones",
		"welcome": "Regístrese y comience a monitorear sus dispositivos",
		"zero-stress": "Sin estrés, sin complicaciones.",
    "create-acc":""
	},
	"fr": {
		"acc": "Vous n'avez pas de compte?",
		"agree": "je suis d'accord avec le",
		"change-lang": "Changer de langue",
		"company": "Entreprise",
		"country": "Pays",
		"create_acc": "Créer un compte",
		"email": "E-mail",
		"fgt-pwd": "Mot de passe oublié?",
		"fullname": "Nom complet",
		"have_acc": "Vous avez déjà un compte?",
		"login": "S'identifier",
		"must_contain": "Ne doit contenir que des lettres",
		"password": "Mot de passe",
		"phone_num": "Numéro de téléphone",
		"real-time": "Avec des décisions fondées sur des données en temps réel.",
		"scale": "Faites évoluer votre opération et",
		"scale-2": "Augmenter la rentabilité",
		"signup": "S'inscrire",
		"signup-text": "Les mots de passe forts doivent comporter 8 caractères avec un mélange de majuscules, de minuscules et de caractères spéciaux",
		"terms": "termes et conditions",
		"welcome": "Inscrivez-vous et commencez à surveiller vos appareils",
		"zero-stress": "Pas de stress, zéro souci.",
    "create-acc":"Créer un compte"
	},
	"sw": {
		"acc": "Hauna akaunti?",
		"agree": "Nakubaliana na",
		"change-lang": "Badilisha Lugha",
		"company": "Kampuni",
		"country": "Nchi",
		"create_acc": "Tengeneza akaunti",
		"email": "Barua pepe",
		"fgt-pwd": "Umesahau nywila?",
		"fullname": "Jina kamili",
		"have_acc": "Tayari unayo akaunti?",
		"login": "Ingia",
		"must_contain": "Lazima iwe na Barua tu",
		"password": "Nenosiri",
		"phone_num": "Nambari ya simu",
		"real-time": "Kwa maamuzi ya wakati halisi yanayoungwa mkono na data.",
		"scale": "Ongeza Uendeshaji wako na",
		"scale-2": "kuongeza faida",
		"signup": "Jisajili",
		"signup-text": "Nywila thabiti zinapaswa kuwa na urefu wa herufi 8 na mchanganyiko wa herufi kubwa, ndogo na herufi maalum",
		"terms": "Masharti na Masharti",
		"welcome": "Jisajili na uanze kufuatilia vifaa vyako",
		"zero-stress": "Hakuna dhiki, sifuri shida.",
    "create-acc":"Fungua akaunti"
	}
}
</i18n>
